// tslint:disable
/**
 * LXBackend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface ClassroomItemCreateMany
 */
export interface ClassroomItemCreateMany {
    /**
     * 
     * @type {string}
     * @memberof ClassroomItemCreateMany
     */
    classroom: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ClassroomItemCreateMany
     */
    items: Array<string>;
}

export function ClassroomItemCreateManyFromJSON(json: any): ClassroomItemCreateMany {
    return {
        'classroom': json['classroom'],
        'items': json['items'],
    };
}

export function ClassroomItemCreateManyToJSON(value?: ClassroomItemCreateMany): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'classroom': value.classroom,
        'items': value.items,
    };
}


